import { LoadingStatusEnum } from '../../../../store/types'
import { BrokerIdentifierList } from '../api/types'

export type BrokerIdentifiersState = {
  list: BrokerIdentifierList
  loading: LoadingStatusEnum
  creating: LoadingStatusEnum
  deletingId: number | null
}

export const createDefaultList = (): BrokerIdentifierList => ({ prop: [], cfd: [] })

const initialState: BrokerIdentifiersState = {
  list: createDefaultList(),
  loading: LoadingStatusEnum.Idle,
  creating: LoadingStatusEnum.Idle,
  deletingId: null,
}

export type StateType = typeof initialState

export default initialState
